module.exports = __webpack_public_path__ + "img/faq-fav-sp.2fdc6a48.jpg";